import React from "react";
import { Flex } from "@chakra-ui/react";
import { type Integration } from "lib/sanity";
import { SyncRow } from "./sync-row";

type Step3FigureProps = {
  source: Integration;
  destination: Integration;
};

export function Step3Figure({ source, destination }: Step3FigureProps) {
  return (
    <Flex
      direction="column"
      w="100%"
      gap={{ base: "smallest", sm: "smaller" }}
      bg="brand.background.light"
      px={{ base: "smaller", sm: "small", md: "smaller", lg: "small", xl: "bigger" }}
    >
      <SyncRow source={source} destination={destination} sourceText="Email" destinationText="Email" />

      <SyncRow source={source} destination={destination} sourceText="Name" destinationText="Name" />

      <SyncRow source={source} destination={destination} sourceText="Total_orders" destinationText="All_orders" />

      <SyncRow source={source} destination={destination} sourceText="Last_login" destinationText="Last_login" />
    </Flex>
  );
}
